import { riskLevel, scheduleStatus } from "../constants/labels";

export const toDate = (value) => {
  if (!value || typeof value !== "string") return null;
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const addDays = (date, amount) => {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
};

export const isSameDate = (left, right) =>
  left?.getFullYear?.() === right?.getFullYear?.() &&
  left?.getMonth?.() === right?.getMonth?.() &&
  left?.getDate?.() === right?.getDate?.();

export const isBetweenDates = (date, start, end) => {
  if (!date || !start || !end) return false;
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const from = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime();
  const to = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime();
  return day >= from && day <= to;
};

export const overlapsRange = (row, start, end) =>
  row.startDate && row.dueDate && row.startDate <= end && row.dueDate >= start;

const formatDate = (date) =>
  date
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
    : "";

const formatShortDate = (value) => {
  const date = typeof value === "string" ? toDate(value) : value;
  return date
    ? `${String(date.getFullYear()).slice(2)}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
    : "";
};

export const normalizeTimelineRows = (items = []) =>
  items
    .map((item) => {
      const startDate = toDate(item.required_start_date || item.check_required_date || item.requested_due_date);
      const dueDate = toDate(item.requested_due_date || item.required_start_date || item.check_required_date);
      if (!startDate || !dueDate) return null;
      const safeStart = startDate <= dueDate ? startDate : dueDate;
      const safeDue = dueDate >= startDate ? dueDate : startDate;
      const riskMeta = riskLevel[item.risk_level] || riskLevel.NORMAL;
      const statusMeta = scheduleStatus[item.schedule_status] || scheduleStatus.WAITING;
      return {
        ...item,
        id: item.order_line_id || `${item.order_id}-${item.line_no || item.item_name_snapshot}`,
        orderId: item.order_id,
        orderNo: item.order_no || "-",
        itemName: item.item_name_snapshot || "품목명 없음",
        customerName: item.customer_name || "-",
        startDate: safeStart,
        dueDate: safeDue,
        startLabel: item.required_start_date || item.check_required_date || item.requested_due_date,
        dueLabel: item.requested_due_date || item.required_start_date || item.check_required_date,
        riskLabel: riskMeta.label,
        riskTone: riskMeta.tone,
        riskBg: riskMeta.bg,
        scheduleLabel: statusMeta.label,
        availableMarginDays: item.available_margin_days,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.startDate - b.startDate || a.dueDate - b.dueDate || String(a.orderNo).localeCompare(String(b.orderNo)));

export const buildGanttTasks = (rows = []) => {
  return rows.map((line, index) => ({
    id: `line-${line.id || line.order_line_id || index}`,
    text: line.itemName,
    start_date: line.startDate,
    end_date: addDays(line.dueDate, 1),
    readonly: true,
    orderId: line.orderId,
    orderNo: line.orderNo,
    customerName: line.customerName,
    itemName: line.itemName,
    startLabel: line.startLabel || formatDate(line.startDate),
    dueLabel: line.dueLabel || formatDate(line.dueDate),
    startShortLabel: formatShortDate(line.startLabel) || formatShortDate(line.startDate),
    dueShortLabel: formatShortDate(line.dueLabel) || formatShortDate(line.dueDate),
    riskLevel: line.risk_level || "NORMAL",
    riskLabel: line.riskLabel,
    scheduleLabel: line.scheduleLabel,
    availableMarginDays: line.availableMarginDays,
  }));
};
